import { render, staticRenderFns } from "./HandbookView.vue?vue&type=template&id=77a6c176&scoped=true&"
import script from "./HandbookView.vue?vue&type=script&lang=js&"
export * from "./HandbookView.vue?vue&type=script&lang=js&"
import style0 from "./HandbookView.vue?vue&type=style&index=0&id=77a6c176&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a6c176",
  null
  
)

export default component.exports